import { lazy, Suspense, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { brochureURL } from "./BrochureDownload.jsx";
import { business, businessProfiles, bbbProfileURL } from "../data/siteContent.js";
import { openAnalyticsPreferences } from "../lib/analytics.js";
const CityLights = lazy(() => import("./CityLights.jsx"));
export default function Footer() {
  const [gameOpen, setGameOpen] = useState(false);
  return <footer className="kw-city-footer">
      <div className="kw-footer-skyline" aria-hidden="true">
        <img src="/images/nyc-silhouette.png" alt="" width="8000" height="2870" loading="lazy" />
      </div>
      <div className="kw-footer-top">
        <div className="kw-footer-brand">
          <Link to="/" className="kw-footer-wordmark" aria-label="Karalewich home">
            <img src="/brand/wordmark.svg" alt="Karalewich" width="180" height="30" loading="lazy" />
          </Link>
          <p>Custom Software & AI Solutions</p>
          <a href={`mailto:${business.publicEmail}`} className="kw-text-link" data-analytics="footer_email" data-analytics-event="email_click">
            {business.publicEmail} <ArrowUpRight size={15} />
          </a>
          <a className="kw-footer-bbb" href={bbbProfileURL} target="_blank" rel="noopener noreferrer" aria-label="Karalewich BBB Accredited Business, A+ rating (opens in a new tab)"><img src="/images/partners/bbb-a-rating.png" alt="BBB Accredited Business, A+ rating" width="96" height="64" loading="lazy" /><span>View our BBB profile <ArrowUpRight size={12} /></span></a>
          <nav className="kw-footer-social" aria-label="Social profiles">
            {businessProfiles.map(([name, url]) => <a key={name} href={url} target="_blank" rel="noopener noreferrer" aria-label={`Karalewich on ${name} (opens in a new tab)`}>{name}</a>)}
          </nav>
        </div>
        <nav className="kw-footer-links" aria-label="Footer navigation">
          <div>
            <span>Explore</span>
            <Link to="/software">Software</Link>
            <Link to="/ai-automation">AI & Automation</Link>
            <Link to="/how-we-work">How we work</Link>
            <Link to="/about">About</Link>
            <Link to="/apps">App portfolio</Link>
            <Link to="/news">News</Link>
            <a href={brochureURL} download="Karalewich-Software-Automation.pdf" target="_blank" rel="noopener noreferrer" data-analytics="brochure_footer" data-analytics-event="link_click">
              Download brochure
            </a>
          </div>
          <div>
            <span>Let’s talk</span>
            <Link to="/contact">Contact us</Link>
            <a href={`tel:${business.phoneHref}`} data-analytics="footer_phone" data-analytics-event="phone_click">
              {business.phone}
            </a>
            <span className="kw-footer-location">
              New Jersey. Working everywhere.
            </span>
          </div>
        </nav>
      </div>
      <div className="kw-footer-bottom">
        <span>© {new Date().getFullYear()} Karalewich LLC</span>
        <div>
          <button type="button" className="kw-footer-game-link" aria-label="Play City Lights" onClick={() => setGameOpen(true)}>After hours ↗</button>
          <Link to="/sitemap">Sitemap</Link>
          <Link to="/privacy">Privacy</Link>
          <button type="button" onClick={openAnalyticsPreferences}>
            Analytics preferences
          </button>
        </div>
      </div>
      {gameOpen && <Suspense fallback={null}><CityLights onClose={() => setGameOpen(false)} /></Suspense>}
    </footer>;
}
